import { useMutation, useQueryClient } from "react-query";
import { mutatePutFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export type KeyDispositionAction =
  | "returned_by_post"
  | "destroyed"
  | "returned_to_owner";

export interface KeyDispositionPayload {
  key_id: string;
  action: KeyDispositionAction;
}

/**
 * PUT /admin/key/disposition — confirm how an uncollected expired key was
 * handled, then retire it (which releases its still-held slot). Requires an
 * active LapsedSubscriptionAlerts for the key and the key back in the box.
 */
export const useKeyDisposition = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, KeyDispositionPayload>(
    (data) => mutatePutFn(ENDPOINTS.KEY_DISPOSITION, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([ENDPOINTS.LAPSED_SUBSCRIPTION_ALERTS]);
      },
    }
  );
};
